import React, { useEffect, useState, useCallback } from "react";
import Sidebar from "../../components/admin/Sidebar";
import Navbar from "../../components/admin/Navbar";
import Footer from "../../components/Footer";
import LogoutModal from "../../components/admin/LogoutModal";
import Meta from "../../components/Meta";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import Loader from "../../components/Loader";
import { Button, Modal } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Paginator } from "primereact/paginator";
import api from "../../services/api";
import _ from "lodash"; // Importação para aplicar debounce

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

const GerUsersScreen = () => {
  const [loading, setLoading] = useState(true);
  const [usersGer, setUsersGer] = useState([]);
  const [show, setShow] = useState(false);
  const [userId, setUserId] = useState("");
  const [email, setEmail] = useState("");
  const [nome, setNome] = useState("");

  const [filterText, setFilterText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalClientes, setTotalClientes] = useState(0);

  const pageSize = 10;

  // Função de busca de usuários com base no texto de pesquisa
  const pesquisaCard = async (page = 1, keyword = "") => {
    setLoading(true);
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const { data } = await api.get(
        `/api/users?page=${page}&pageSize=${pageSize}&keyword=${keyword}`,
        config
      );
      setUsersGer(data.users);
      setTotalRecords(data.pages * pageSize);
      setCurrentPage(data.page);
      setTotalClientes(data.totalClients);
    } catch (error) {
      toast.error("Erro ao carregar usuários");
    }
    setLoading(false);
  };

  // Debounce da busca
  const debounceSearch = useCallback(
    _.debounce((searchText) => {
      pesquisaCard(1, searchText);
    }, 800),
    []
  );

  // Função para capturar pressionamento da tecla Enter para iniciar a busca
  const onKeyDownHandler = (e) => {
    if (e.key === "Enter") {
      debounceSearch(filterText);
    }
  };

  // Função chamada quando o filtro de busca muda
  const onFilterChange = (e) => {
    const searchText = e.target.value;
    setFilterText(searchText);
  };

  // Função de edição de usuário
  const editUser = (rowData) => {
    setUserId(rowData._id);
    setNome(rowData.nome);
    setEmail(rowData.email);
    setShow(true);
  };

  // Função de exclusão de usuário
  const deleteUser = async (id) => {
    const confirmDelete = window.confirm("Tem certeza que deseja excluir este usuário?");
    if (!confirmDelete) return;

    try {
      const config = { headers: { "Content-Type": "application/json" } };
      await api.delete(`/api/users/${id}`, config);
      toast.success("Usuário removido com sucesso!");
      pesquisaCard(currentPage);
    } catch (error) {
      toast.error("Erro ao excluir usuário");
    }
  };

  // Função de reenviar e-mail de confirmação
  const reenvioConfirmacao = async (user) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      await api.post("/api/users/reenviar-email", {
        id: user._id,
        email: user.email,
        nome: user.nome,
      }, config);
      toast.success(`Confirmação de e-mail reenviada para ${user.email}`);
    } catch (error) {
      toast.error("Erro ao reenviar e-mail.");
    }
  };

  // Função para as ações do usuário (editar, excluir, reenviar e-mail)
  const actionTemplate = (rowData) => (
    <>
      <Button
        variant="warning"
        size="sm"
        onClick={() => editUser(rowData)}
        className="mr-2"
      >
        <i className="pi pi-pencil"></i> Editar
      </Button>
      <Button
        variant="danger"
        size="sm"
        onClick={() => deleteUser(rowData._id)}
        className="mr-2"
      >
        <i className="pi pi-trash"></i> Excluir
      </Button>
      <Button
        variant="info"
        size="sm"
        onClick={() => reenvioConfirmacao(rowData)}
      >
        <i className="pi pi-envelope"></i> Reenviar e-mail
      </Button>
    </>
  );

  // Função para atualizar o usuário
  const submitHandler = async () => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      await api.post("/api/users/gerencia-email", { id: userId, email, nome }, config);
      toast.success("Usuário atualizado com sucesso!");
      setShow(false);
      pesquisaCard(currentPage);
    } catch (error) {
      toast.error("Erro ao atualizar usuário");
    }
  };

  useEffect(() => {
    pesquisaCard();
  }, []);

  return (
    <>
      <ToastContainer />
      <Meta />
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Navbar />

            {loading ? (
              <Loader />
            ) : (
              <div className="container-fluid">
                <div className="d-sm-flex align-items-center justify-content-between mb-3">
                  <h1 className="h3 mb-0 text-gray-800">Gerenciamento de Usuários</h1>
                  <p>Total de clientes inscritos: {totalClientes}</p>
                </div>

                <div className="mb-3">
                  <InputText
                    value={filterText}
                    onChange={onFilterChange}
                    onKeyDown={onKeyDownHandler} // Chama a pesquisa apenas quando Enter é pressionado
                    placeholder="Buscar por nome, CPF ou e-mail"
                    className="p-inputtext-sm w-100"
                  />
                </div>

                <DataTable value={usersGer} paginator={false} responsiveLayout="scroll">
                  <Column field="_id" header="Código" sortable />
                  <Column field="nome" header="Nome" sortable />
                  <Column field="email" header="E-mail" sortable />
                  <Column field="cpf" header="CPF" />
                  <Column body={actionTemplate} header="Opções" style={{ width: "30%" }} />
                </DataTable>

                <Paginator
                  first={(currentPage - 1) * pageSize}
                  rows={pageSize}
                  totalRecords={totalRecords}
                  onPageChange={(e) => pesquisaCard(e.page + 1, filterText)}
                />
              </div>
            )}
          </div>
          <Footer />
        </div>
      </div>
      <LogoutModal />

      {/* Modal de edição */}
      <Modal
        show={show}
        onHide={() => setShow(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Editar usuário</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={submitHandler}>
            <div className="form-group row">
              <div className="col-sm-6">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nome"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                />
              </div>
              <div className="col-sm-6">
                <input
                  type="email"
                  className="form-control"
                  placeholder="E-mail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>
            <Button type="submit" className="btn btn-primary">
              Salvar alterações
            </Button>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GerUsersScreen;
